import { useEffect, useState } from 'react';

/** The console's one layout breakpoint (§7.6): side rail and full tables at 1024 px and wider. */
export const DESKTOP = '(min-width: 1024px)';

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => Boolean(window.matchMedia?.(query).matches));
  useEffect(() => {
    const media = window.matchMedia?.(query);
    if (!media) return undefined;
    const update = () => setMatches(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [query]);
  return matches;
}
